// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.adminSideMenu {
  width: 250px;
  background-color: #fffbf8;
  height: 100%;
  padding-top: 20px;
}

.adminMenuItem {
  display: flex;
  align-items: center;
  padding: 15px 20px;
  color: #333;
  text-decoration: none;
  margin-bottom: 5px;
  transition: background-color 0.3s;
}

.adminMenuItem:hover {
  background-color: #fff0e6;
}

.adminMenuItem.active {
  background-color: #fff0e6;
  color: #FF6F0F;
  border-left: 3px solid #FF6F0F;
}

.adminMenuIcon {
  margin-right: 10px;
  display: inline-block;
  width: 20px;
  text-align: center;
} `, "",{"version":3,"sources":["webpack://./src/styles/admin/AdminSideMenu.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,kBAAkB;AACpB","sourcesContent":[".adminSideMenu {\n  width: 250px;\n  background-color: #fffbf8;\n  height: 100%;\n  padding-top: 20px;\n}\n\n.adminMenuItem {\n  display: flex;\n  align-items: center;\n  padding: 15px 20px;\n  color: #333;\n  text-decoration: none;\n  margin-bottom: 5px;\n  transition: background-color 0.3s;\n}\n\n.adminMenuItem:hover {\n  background-color: #fff0e6;\n}\n\n.adminMenuItem.active {\n  background-color: #fff0e6;\n  color: #FF6F0F;\n  border-left: 3px solid #FF6F0F;\n}\n\n.adminMenuIcon {\n  margin-right: 10px;\n  display: inline-block;\n  width: 20px;\n  text-align: center;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
